// @flow
import React, { Children, type Node } from 'react';
import classnames from 'classnames';
import { isInteger } from 'lodash';

import { BREAKPOINTS, DEFAULT_CELL_COLS } from 'Components/utils/responsive/Responsive.constants';

type Props = {
  children: Node,
  className?: string,
  cols?: { [breakpointName: $Keys<typeof BREAKPOINTS>]: number },
  id?: string,
  offsets?: { [breakpointName: $Keys<typeof BREAKPOINTS>]: number },
};

function getClass(prop, key, css) {
  // $FlowFixMe
  return prop.hasOwnProperty(key) && isInteger(prop[key]) && prop[key] > 0
    ? ` ${key}${css}${prop[key]}`
    : '';
}

function getResponsiveClasses({ cols = DEFAULT_CELL_COLS, offsets = {} }) {
  const cellCols = { ...DEFAULT_CELL_COLS, ...cols };

  return Object.keys(BREAKPOINTS)
    .map(key => {
      return (
        getClass(cellCols, BREAKPOINTS[key], '-GridCell--') +
        getClass(offsets, BREAKPOINTS[key], '-GridCell--offset-')
      );
    })
    .join('');
}

export class GridCell extends React.Component<Props> {
  render() {
    const { children, className, id } = this.props;

    if (!Children.count(children)) return null;

    return (
      <div
        className={classnames(
          className,
          'flex-1 max-w-full',
          `GridCell${getResponsiveClasses(this.props)}`,
        )}
        id={id}
      >
        {children}
      </div>
    );
  }
}
